import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/i18n"; // Initialize i18n
import App from "@/App";
import { registerServiceWorker } from "@/sw-register";
import { initConfig } from "config";

// Suppress benign ResizeObserver error in dev overlay
const ro = window.addEventListener("error", (e) => {
  if (e.message?.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Load runtime config then mount the app
initConfig().finally(() => {
  root.render(
    <React.StrictMode>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </React.StrictMode>,
  );
});

// EPIC 2 (T10): Register Service Worker for PWA
registerServiceWorker();
